import service from '@/services/contabilidad/account'

const getDefaultState = () => ({
  list: [],
  listTypes: []
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  SET: (state, obj) => {
    state.list = obj
  }
}

export const actions = {
  resetList: ({ state }) => {
    state.list = []
    state.listTypes = []
  },

  readAllByEmisor: async ({ commit, state, dispatch, rootGetters }, { restart = false }) => {
    if (restart) await dispatch('resetList')

    if (state.list.length) {
      console.log('(Conta) Account from cache ⏩')
      return
    }

    // es necesario cargar los tipos??
    // dispatch('readAllTypesByEmisor')

    return service.readAllByEmisor(rootGetters['facturacion/emisorStore/get_Id']).then(response => {
      console.log('(Conta) Account from DB 😅')

      commit('SET', response)
    })
  },

  readAllTypesByEmisor: async ({ state, rootGetters }) => {
    return service.readAllTypesByEmisor(rootGetters['facturacion/emisorStore/get_Id']).then(response => {
      state.listTypes = response
    })
  },

  setDefaults: async ({ dispatch, rootGetters }) => {
    return service.setDefaults(rootGetters['facturacion/emisorStore/get_Id']).then(async response => {
      console.log('(Conta) Account setDefaults ready ✅')

      const account = await service.setDefaultsAccounts(rootGetters['facturacion/emisorStore/get_Id'])
      console.log('(Conta) Account setDefaultsAccounts ready ✅')

      await dispatch('readAllByEmisor', { restart: true })
      await dispatch('readAllTypesByEmisor')

      return true
    })
  }
}

export const getters = {
  getAccountByReport: state => value => {
    return state.list.filter(e => e.accountType.report === value)
  },
  getAccountByCategory: state => value => {
    return state.list.filter(e => e.accountType?.category === value)
  },
  getAccountByType: state => value => {
    return state.list.filter(e => e.accountType.type === value)
  },
  getList: state => {
    return state.list
  }
}
